/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getStripeAccessDetailsForCustomer} from '../api'

 export const useQueryGetStripeAccessDetailsForCustomer = createReactQueryHook('getStripeAccessDetailsForCustomer', getStripeAccessDetailsForCustomer)
